import _Icon from './svg-sprite.js';
import '../_chunks/dep-22bff531.js';
import 'vue';
import '../utils/config-context.js';
import '../utils/use-size-props.js';
import '../utils/use-common-classname.js';
import '../utils/check-url-and-load.js';
import './props/props.js';
import '../style/css.js';

var Icon = _Icon;

export default Icon;
export { Icon };
//# sourceMappingURL=index.js.map
